import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './routing/app.routes';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { authConfig } from './util/auth.config';
import { provideAuth } from 'angular-auth-oidc-client';
import { authInterceptor } from './interceptors/auth';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideAuth(authConfig),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
  ],
};
